import React from "react";
import { get } from "lodash";
import Divider from "material-ui/Divider";
import { Flex, Box, Text, Image } from "rebass";
const List = (props) => {
  const { values } = props;
  const header = get(values, "header", "");
  const aligHeader = get(values, "alignHeader", "center");
  const list = get(values, "list", []);
  const columnDesktop = get(values, "columnDesktop", 2);

  return (
    <Box width={[1]}>
      <Flex width={[1]} style={{ justifyContent: aligHeader }}>
        <Text fontSize={[2, 3]} p={[2]} style={{ color: "#00BFFF" }}>
          {header}
        </Text>
      </Flex>
      <Divider />
      <Box width={[1]}>
        <Flex width={[1]} style={{ display: "flex", flexWrap: "wrap" }}>
          {list &&
            list.length > 0 &&
            list.map((item, index) => {
              const imageUrl = get(item, "imageUrl.urlMobile", "");
              const title = get(item, "title", "");
              const discount = get(item, "discount", "");
              const titleDiscount = get(item, "titleDiscount", "");
              return (
                <Box width={[1, 1 / columnDesktop]} key={index} p={[1]}>
                  <Flex
                    width={[1]}
                    style={{ border: "1px solid #c4c4c4" }}
                    p={[2]}
                  >
                    <Box width={["80px", "180px"]}>
                      <Image src={imageUrl} />
                    </Box>
                    <Box width={[1]} p={[2]}>
                      <Text fontSize={[2, 3]}>{title}</Text>
                      <Flex
                        width={[1]}
                        style={{
                          flex: 1,
                          flexDirection: "row",
                          alignItems: "stretch",
                          display: "flex",
                        }}
                      >
                        <Flex
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Text style={{ color: "#00BFFF" }}>
                            {titleDiscount}
                          </Text>
                        </Flex>
                        <Box
                          p={[1]}
                          m={[1]}
                          style={{
                            backgroundColor: "#FF3B3B",
                            borderRadius: "100%",
                            paddingTop: "13px",
                            paddingBottom: "13px",
                            paddingLeft: "8px",
                            paddingRight: "8px",
                          }}
                        >
                          <Text fontSize={[0]} color={"white"}>
                            {discount}%
                          </Text>
                        </Box>
                      </Flex>
                    </Box>
                  </Flex>
                </Box>
              );
            })}
        </Flex>
      </Box>
    </Box>
  );
};

export default List;



// WEBPACK FOOTER //
// ./src/editor/components/dealgroup/List.js